import {
  Component,
  ViewChild,
  OnInit,
  ChangeDetectorRef,
  Renderer2,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TournamentsService } from "src/app/services/tournamnet.service";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { environment } from "src/environments/environment";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { LazyLoadEvent, MessageService } from "primeng/api";
import { AuthService } from "src/app/services/auth.service";
import { RoleService } from "src/app/services/role.service";
import { CustomValidators } from "ng2-validation";
import { MustMatch } from "src/app/_helpers/must-match.validator";
import { CategoryService } from "src/app/services/category.service";
import { UserWalletService } from "src/app/services/userWallet.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";
import { WindowRefService } from "src/app/services/window-ref.service";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Subscription, timer } from "rxjs";
import { take } from "rxjs/operators";
import * as momentNamespace from "moment";
import { CommonService } from "src/app/services/common.service";
import { ChargesService } from "src/app/services/charges.service";
const moment = momentNamespace as any;
interface filterCategory {
  name: string;
}
interface filterAcademy {
  name: string;
}
interface filterSurface {
  name: string;
}
interface filterState {
  name: string;
}
interface filterCity {
  name: string;
}
interface filterMonth {
  name: string;
}
interface filterYear {
  name: string;
}
interface tournamentCategories {
  label: string;
}
interface ageCategory {
  name: string;
}
interface AgeGroupData {
  label: string;
  value: string | null;
  entryFee: number;
  maxPlayer: number;
  tournamentCategoryId: string | null;
}

@Component({
  selector: "app-tournament-factsheet",
  templateUrl: "./tournament-factsheet.component.html",
  styleUrls: ["./tournament-factsheet.component.scss"],
  providers: [WindowRefService],
})
export class TournamentFactsheetComponent implements OnInit {
   position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
  totalPlayercount = 0;
  isShareButtonClicked: boolean = false;
  public tournamentId;
  public loggedInUser;
  public loggedinUserrole;
  public showRegisterButton: boolean = true;
  private lazyLoadEvent: LazyLoadEvent;
  public loading: boolean = false;
  public currentDate = new Date();
  public currentMonth = this.currentDate.getMonth();
  public currentYear = this.currentDate.getFullYear();
  public selectedMonth;
  public selectedYear = [this.currentDate.getFullYear()];
  public selectedCategory;
  public totalRecords = 0;
  public errorMessage: string;
  public registrationCategoryErrorMessage: string = null;
  public agecatlist = [];
  public userCategories: any[] = [];
  public selectedageGroup;
  public countDown: Subscription;
  public counter;
  public shareurl;
  public otp: string;
  public showForgotPasswordForm: boolean = false;
  public showOtpErrors: boolean = false;
  public showOtpErrorsMsg: boolean = false;
  public showMobileLoginOtpForm: boolean = false;
  public tick;
  public showResendButton: boolean = false;
  public showMobileFormErrors: boolean = false;
  public mobileFormsErrors: boolean = false;
  public otpLoginErrors: boolean = false;
  public showOtpLoginErrors: boolean = false;
  public otpErrorMessage;
  public displayTime;
  public mobileNumber;
  public showOtpForm: boolean = false;
  public downloadModal: boolean = false;
  public successMessage;
  parentcatList: any[] = [];
  showMessage: boolean = false;
  @ViewChild("ngOtpInput", { static: false }) ngOtpInput: any;
  public config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: "",
    inputStyles: {
      width: "50px",
      height: "50px",
    },
  };
  subAgegroup: Array<
    {
      label: string;
      value: string;
      entryFee: number;
      maxPlayer: number;
      tournamentCategoryId: string;
    }[]
  > = [];
  walletBalance: number;
  showAddMoneyMessage: boolean = false;
  isRadioButtonClicked: boolean = true;
  matchName: any;
  to: any;
  categoryName: any;
  categoryData: any;
  selectedTournamentCityName: string;
  showPmdtaNumber: boolean;
  diableConfirmButton: boolean;
  selectedPmdtaNumber: any[];
  showDoublePmdtaNumber: boolean;
  termsAndConditions: any;
  addPartnerTermsAndConditions: any;
  walletDialogTermsAndConditions: any;
  termsAndConditionsCheck: boolean;
  showTermsAndConditionError: boolean;
  welcomeLogin: boolean = false;
  isContestVerified: boolean;
  isAbove18Check: boolean;
  drawType: any;
  googleMapLink: any;
  prizePool: any;
  organizerName: any;
  organizerPhoneCode: any;
  rulesTitle: any;
  rulesDescription: any;
  rulesTitleTwo: any;
  rulesDescriptionTwo: any;
  showplayerList: any;
  refundTournamentCategoriesMessage: string | null = null;
  showNoCategories: boolean = false;
  isRegistrationExpired = false;
registrationDeadlineTimer: any;
  getPriceFormControlName(index: number): string {
    return `price_${index}`;
  }
  isRegisterButtonEnabled(): boolean {
    // this.showAddMoneyMessage = this.walletBalance < this.totalEntryFee();
    // return (
    //   this.isRadioButtonClicked && this.walletBalance >= this.totalEntryFee()
    // );
    return this.showAddMoneyMessage = false;
  }
  registeredtournamentdata: any[] = [];
  matchCheckingArray: any[] = [];
  submitted = false;
  totalCash: number = 0;
  totalDeductedCash: number = 0;
  totalAvailableCash: number = 0;
  totalleftCash: number;

  public walletlist: any = [];
  withdrawButtonClicked: boolean = false;
  countdownInProgress: boolean = false;
  countdown: number = 10;
  walletdata: any;
  withdrawtournamentData: any;
  added_amount: number = 0;
  isFieldAdded: boolean = false;
  isConfirmButtonDisabled = true;
  selectedAgeGroupIndices: number[] = [];
  //subAgegroup: Array<{ label: string; value: string; entryFee: number }[]> = [];
  selectedEntryFees: number[] = []; // Array to store the selected age group entry fees
  selectedMatchTypes: string[] = [];
  selectedAgeGroups: string[] = [];
  selectedFieldGroups: any[];
  selectedEntryFee: number = 0;
  selectedTournamentCategory: string[] = []; // Explicitly type as string[]
  selectedAgeGroup: string[] = []; // Explicitly type as string[]
  showDoublesPartnerSection: boolean = false;
  addedAmount: number | null = null;
  selectedMatchTypeIds: string[] = [];
  selectedAgeGroupIds: string[] = [];
  addCashForm: FormGroup;
  wid: any;
  tname: any;
  mtn: any;
  agn: any;
  withdraw_confirm_status: boolean = false;
  outdate_reg_status: boolean = false;
  emailForm: FormGroup;
  registrationForm: FormGroup;
  myForm: FormGroup;
  partneremailid: any;
  partneremailemail: any = null;
  emailerrormsg: boolean = false;
  search_email: any;
  duplicateEmailError: boolean = false;
  partner_email_index: any;
  loginemailid;
  selectedGender: any = null;
  genders;
  forgotPassForm: FormGroup;
  signUpForm: FormGroup;
  permissions: any[] = [];
  permissionArray: any[] = [];
  userTypeListArray: any[] = [];
  rolelist: any[] = [];
  doublecatarray: any[] = [];
  trainerRoleId;
  roles;
  userType;
  userData;
  isLoginFailed: boolean;
  loginForm: FormGroup;
  mobileLoginForm: FormGroup;
  loginFormSubmitted: boolean = false;
  tournamentIds: string[] = [];
  tourcatList: any[];
  isLoggedIn: boolean = false;
  filterByCategorySelected;
  tournamentList: any;
  imagedataa: any;

  id: any;
  item: any;
  tournamentname: any;
  courttype: any;
  cityname: any;
  statename: any;
  startdate: any;
  enddate: any;
  lastdateofregistration: any;
  lastdateofwithdraw: any;
  academyName: any;
  academyPic: any;
  academyId: any = [];
  address: any;
  Categoryfilter: filterCategory[] | undefined;
  selectedfilterCategory: filterCategory | undefined;
  Academyfilter: filterAcademy[] | undefined;
  selectedfilterAcademy: filterAcademy | undefined;
  Surfacefilter: filterSurface[] | undefined;
  selectedfilterSurface: filterSurface | undefined;
  Statefilter: filterState[] | undefined;
  selectedfilterState: filterState | undefined;
  Cityfilter: filterCity[] | undefined;
  selectedfilterCity: filterCity | undefined;
  Monthfilter: filterMonth[] | undefined;
  selectedfilterMonth: filterMonth | undefined;
  Yearfilter: filterYear[] | undefined;
  selectedfilterYear: filterYear | undefined;
  ageCategory: ageCategory[] | undefined;
  selectedageCategory: ageCategory | undefined;
  rangeDates: Date[] | undefined;
  visible: boolean = false;
  TournamentEntry: boolean = false;
  addPartner: boolean = false;
  Walletdialog: boolean = false;
  Addcashmodal: boolean = false;
  thanYoumodal: boolean = false;
  WithdrawModal: boolean = false;
  WithdrawcnfModal: boolean = false;
  thankwithdraw: boolean = false;
  displayCashMs: boolean = false;
  isActive: boolean = false;
  isActive2: boolean = false;
  outputText: string;
  value!: string;
  viewPlayerList: boolean;
  loggedInAcademy;
  loggedInAcademyId;
  zipcode: any;
  countryname: any;
  organizercontactnumber: any;
  whatsAppgrouplink: any;
  tournamentCategories: any;
  regulations: any;
  sponsor_logo: any;
  userAccess: boolean = true;
  showPage: boolean = true;
  tournamentUrl = environment.frontEnd.domain + "/tournaments/";
  isMobileDevice: boolean;
  isAndroid: boolean;
  isiOS: boolean;
  public ownlink: boolean;
  test: any[] = [
    { label: "Select Tournament Category", value: "Pass" },
    { label: "Singles", value: "Pass" },
    { label: "Doubles", value: "Fail" },
    { label: "Mixed Doubles", value: "Fail" },
  ];
  testCategory: string;
  displayFail: boolean = false;
  public courtTypeList = environment.courtTypeList;
  public loginmobileNumber;
  thankYouMsg: boolean = false;
  categoryAndAgeGroupList: any[] = [];
  selectedCategoryAndAgeGroupList: any[] = [];
  disableCategories: boolean[] = [];
  originalCategoryAndAgeGroupList: any;
  isTournamentCatgeorySelected: boolean = false;
  selectableCategoryList: any[] = [];
  fullCategoryList: any[] = [];
  categoryList: any[] = [];
  tournamentName: string = null;
  cityListData: any;
  academyListData: any;
  public countryCodeList: any[] = []; 
  selectedCountryCode: any;
  
  onCategoryChange() {
    this.displayFail = this.testCategory === "Fail";
  }
  fees:any;
  isRefundTournamentCategoriesCompleted: boolean = false;
   outdate_withdraw_status: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private tournamentsService: TournamentsService,
    private router: Router,
    private renderer: Renderer2,
    private authService: AuthService,
    private roleService: RoleService,
    private formBuilder: FormBuilder,
    private elementRef: ElementRef,
    private winRef: WindowRefService,
    private walletpaymentService: WalletpaymentService,
    private userWalletService: UserWalletService,
    private fb: FormBuilder,
    private tokenStorage: TokenStorageService,
    private breakpointObserver: BreakpointObserver,
    private tournamentService: TournamentsService,
    private cdr: ChangeDetectorRef,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private chargesService: ChargesService
  ) {
    this.registrationForm = this.fb.group({
      tournamentId: ["", Validators.required],
      userId: ["", Validators.required],
      matchTypeId: ["", Validators.required],
      ageGroupId: ["", Validators.required],
      entryFee: ["", Validators.required],
    });
    this.myForm = this.fb.group({
      fields: this.fb.array([]), // You might need to initialize this properly based on your use case
    });
    // this.emailForm = new FormGroup({
    //   search_email: new FormControl("", [
    //     Validators.required,
    //     Validators.email,
    //     CustomValidators.email,
    //   ]),
    // });
    this.emailForm = new FormGroup({
      phoneCode: new FormControl(""),
      mobileNumber: new FormControl("", [
        Validators.required,
        Validators.maxLength(10),
      ]),
    });
  }

  ngOnInit(): void {
    this.renderer.addClass(document.body, "factSheet-page");
    this.roleService.setCurrentActiveRoute(this.router.url);
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.resetCountdown();
    this.myForm = this.fb.group({
      fields: this.fb.array([this.createFieldGroup()]),
    });
    this.addCashForm = this.formBuilder.group({
      amount: [null, [Validators.required]],
    });

    /*Login part */
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser && this.loggedInUser.userdata) {
      this.isContestVerified = this.loggedInUser.userdata.isContestVerified;
      this.isAbove18Check = this.loggedInUser.userdata.isAbove18;
      this.isLoggedIn = true;
    }

    //console.log("this is me");
    if (Object.keys(this.loggedInUser).length > 0) {
      //console.log("this is me2");
      this.loggedinUserrole = this.loggedInUser.userdata.rolename;
      if (this.loggedinUserrole === "academy") {
        this.showRegisterButton = false;
      } else {
        //console.log("this is me3");
        this.showRegisterButton = true;
      }
      // if (this['cityname'] == "Pune") {
      //   this.showPmdtaNumber = true;
      // }
      // else {
      //   this.showPmdtaNumber = true;
      // }
      this.tournamentsService
        .getTournamentIds(this.loggedInUser.userdata.id)
        .subscribe(
          (tournamentIds: string[]) => {
            this.tournamentIds = tournamentIds;
            //console.log('Tournament IDs final:', this.tournamentIds);
          },
          (error: any) => {
            //console.error("Error getting tournament IDs:", error);
          }
        );
    } else {
      //console.log("this is me4");
      this.showRegisterButton = true;
    }

    this.loginForm = this.formBuilder.group({
      email: [
        "",
        [Validators.required, Validators.email, CustomValidators.email],
      ],
      password: ["", [Validators.required, Validators.minLength(6)]],
    });

    const storedWalletBalance = localStorage.getItem("walletBalance");
    //this.loggedInUser = this.tokenStorage.getUser();

    if (storedWalletBalance) {
      this.walletBalance = storedWalletBalance
        ? parseFloat(storedWalletBalance)
        : 0;
    } else {
      this.walletBalance = 0; // Default value if not found in localStorage
    }

    
    this.Surfacefilter = [
      { name: "Select Surface" },
      { name: "Hard" },
      { name: "Clay" },
      { name: "Grass" },
    ];

    this.Monthfilter = [{ name: "Select Month" }, { name: "January" }];
    this.Yearfilter = [{ name: "Select Year" }, { name: "2023" }];

    this.tournamentId = this.route.snapshot.paramMap.get("id");
    this.loggedInAcademy = this.tokenStorage.getUser();

    this.getCountryCodes();

    if (Object.keys(this.loggedInAcademy).length > 0) {
      this.loggedInAcademyId = this.loggedInAcademy.userdata["academyId"];
      let academyPaymentDetails =
        this.loggedInAcademy.userdata.academyPaymentDetails;
      if (this.loggedInAcademyId == undefined) {
        this.viewPlayerList = false;
      } else {
        this.viewPlayerList = true;
      }
    }
    this.mobileLoginForm = this.formBuilder.group({
      mobileNumber: [
        null,
        [Validators.required, Validators.pattern("[0-9 ]{10}")],
      ],
    });

    this.getTournamentsDetails();
    this.loadTournament(this.lazyLoadEvent);
    this.getPlatformAndConvenienceFees();
    this.getTotalTournamentPlayerCount();
    //this.getTournamentsLocation();
    this.getUserBalance();
    this.tournamentsService.findBySlug().subscribe((data) => {
      this.doublecatarray = data;
    });

    // this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
    //   const userAgent = window.navigator.userAgent.toLowerCase();
    //   this.isAndroid = userAgent.includes('android');
    //   this.isiOS = userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod');
    //   if (this.isAndroid) {
    //     window.parent.close();
    //     window.location.replace('https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share');
    //   } else if (this.isiOS) {
    //     window.parent.close();
    //     window.location.replace('https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254');
    //   }
    // });
  }
  
  getPlatformAndConvenienceFees() {
    this.chargesService.getPlatformAndConvenienceFees().subscribe((data:any) => {
      this.fees = data.data.items.map(ele => ele.fees.tournament)[0];
    }, err => {
        this.errorMessage = err.error.message;
    })
  }

  startCountdown(): void {
    this.countdownInProgress = true;
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(interval);
        this.countdownInProgress = false;
      }
    }, 1000);
  }

  resetCountdown(): void {
    this.countdown = 10;
    this.countdownInProgress = false;
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, "factSheet-page");
  }

  getTournamentsDetails() {
    this.loading = true;
    this.tournamentsService
      .getTournamentsDetails(this.tournamentId)
      .subscribe((res) => {
        this.loading = false;
        this.item = res;
        //show error if tournament status is false
        this.showPage = this.item.status;
        if (this.loggedinUserrole == "academy") {
          this.userAccess = true;
          this.showPage = true;
        } else {
          this.userAccess = this.item.status;
        }

        this.tournamentId = res?.id;
        this.tournamentname = res?.name;
        this.tournamentCategories = res?.tournamentCategories.map(ele => { 
          return { category: ele['matchtypeData'][0]['name'] + ' ' + ele['ageGroupData'][0]['name'], entryFee: ele.entryFee, drawSize: ele.maxPlayer };
        });
        this.categoryData = res?.tournamentCategories;
        // console.log(res?.tournamentCategories);
        this.academyName = res?.academyName;
        this.showplayerList = res?.showplayerList;
        this.cityname = res?.cityname;
        this.statename = res?.statename;
        this.zipcode = res?.zipcode;
        this.countryname = res?.countryname;
        this.organizerPhoneCode = res?.organizerPhoneCode;
        this.organizerName = res?.organizerName;
        this.organizercontactnumber = res?.organizercontactnumber;
        this.whatsAppgrouplink = res?.whatsAppgrouplink;
        this.regulations = res?.regulations;
        this.sponsor_logo = res?.sponsor_logo;
        this.startdate = res?.startdate;
        this.enddate = res?.enddate;
        this.lastdateofregistration = res?.lastdateofregistration;
        this.lastdateofwithdraw = res?.lastdateofwithdraw;
        this.drawType = res?.drawTypeNames;
        this.googleMapLink = res?.googleMap;
        this.prizePool = res?.prizePool;
        this.rulesTitle = res?.rulesTitle;
        this.rulesDescription = res?.rulesDescription;
        this.rulesTitleTwo = res?.rulesTitleTwo;
        this.rulesDescriptionTwo = res?.rulesDescriptionTwo;
        //console.log(environment.frontEnd.domain)
        this.address = res?.address;
        let cateArray = [];
        res?.tournamentCategories.forEach((element) => {
          // element.ageGroupData.forEach(data => {

          //   cateArray.push(data.name);
          // });
          // element.matchtypeData.forEach(data => {

          //   cateArray.push(data.name);
          // });
          cateArray.push(
            element.ageGroupData[0].name + " " + element.matchtypeData[0].name
          );
        });

        let tmp = this.courtTypeList.find(
            (o) => o.value === this.item.courttype
          );
          if (tmp != undefined) {
            this.item.court = tmp.label;
          } else {
            this.item.court = "";
          }

          let tmpcat = [];
          let pointsData = [];
          let entryFeeData = [];
          let t = this.item.tournamentCategories;
          if (t != undefined) {
            t.forEach((catelement) => {
              tmpcat.push(catelement.matchtypeData);
              pointsData.push(catelement.pointStructureData);
              entryFeeData.push(catelement.entryFee);
            });
          }

          let minimumEntryFee = (entryFeeData.length > 0) ? Math.min(...entryFeeData) : null;
          let maximumEntryFee = (entryFeeData.length > 0) ? Math.max(...entryFeeData) : null;
          this.item.minimumEntryFee = minimumEntryFee;
          this.item.maximumEntryFee = maximumEntryFee;

          let uniqueData = [];
          let uniqueIds = {};
          tmpcat.forEach((item) => {
            if (!uniqueIds[item[0]["name"]]) {
              uniqueIds[item[0]["name"]] = true;
              uniqueData.push(item[0]["name"]);
            }
          });

          let uniquePointsData = [];
          pointsData.forEach((item) => {
            if (!uniquePointsData.includes(item[0]['name'].replace(' Points', ''))) {
              uniquePointsData.push(item[0]['name'].replace(' Points', ''));
            }
          })
          // element.matchDataName=Object.keys(uniqueIds);
          this.item.matchDataName = uniqueData.length > 0 ? uniqueData : null;
          this.item.pointsDataName = uniquePointsData;
          // element.matchDataName = uniqueData.join(", ");

          // if (element["cityname"] == "Pune") {
          //   element["showPmdtaNumber"] = true;
          // } else {
          //   element["showPmdtaNumber"] = false;
          // }
        // console.log(cateArray.join(', '));
        // res.tournamentCategories.forEach(element => {
        //   this.categoryData = element.matchtypeData[i].name;
        //   for (var i = 0; i < this.categoryData.length; i++) {
        //   console.log(this.categoryData[i]);
        // }
        // });
        this.courtTypeList.forEach((element) => {
          const heading =
            "_Join_" +
            " _*" +
            this.tournamentname +
            "*_ " +
            "_and start climbing up the ranking ladder to win the RTG Scholarship!🎾🏆_ ";
          const subheading = "*🎾Categories:* " + cateArray.join(", ");
          // console.log(cateArray);
          // const titleparagraph = 'We are thrilled to announce the ' + this.tournamentname + ' happening on ' + moment(this.startdate).format('DD-MM-YYYY') + ' at ' + this.cityname + '. 🏆 ';
          const lastdate =
            "*🗓️Last Date Of Registration:* " +
            moment(this.lastdateofregistration).format("DD-MM-YYYY");
          const startdate =
            "*🗓️Tournament Date:* " +
            moment(this.startdate).format("DD-MM-YYYY");
          // const Tend = '*🗓️ Tournament End Date: ' + moment(this.enddate).format('DD-MM-YYYY') + '*';
          // const Wd = '*🕒 Withdrawal Date: ' + moment(this.lastdateofwithdraw).format('DD-MM-YYYY') + '*';
          const location =
            "*📍Location:* " +
            this.address +
            ", " +
            this.cityname +
            ", " +
            this.statename +
            ", " +
            this.zipcode;
          // const bottommsg = "Whether you're a seasoned player or just starting out, this tournament is the perfect opportunity to showcase your skills and have a blast on the court. It's all about friendly competition and the love of the game! 🎾💥";
          // const heiglishheading = '*Tournament Highlights:*';
          //const cat = 'Categories : [All categories Name]';
          //const currentPageLink = window.location.href;
          // const currentPageLink = environment.frontEnd.domain + '/tournaments/factsheet/' + this.tournamentId;
          const link =
            "*Tap on the link to Register:* " +
            environment.frontEnd.domain +
            "/tournaments/factsheet/" +
            this.tournamentId;
          // const pagelink = ;

          const org =
            "*For any queries Contact* " +
            "*" +
            this.academyName +
            "*" +
            " at " +
            "+91 " +
            this.organizercontactnumber;
          // const text = "Let's hit the court together and make this tournament an unforgettable experience! 🎾🏆";
          const seeyou = "_*Register Now only on the TPL App*_";
          // const phoneNumber = '1234567890'; // Replace with the recipient's phone number

          // const siteIconUrl = 'https://www.tplsport.com/favicon.ico'; // Replace with your site's icon URL

          // Construct the WhatsApp sharing URL
          const message = encodeURIComponent(
            heading +
              "\n" +
              "\n" +
              subheading +
              "\n" +
              lastdate +
              "\n" +
              startdate +
              "\n" +
              location +
              "\n" +
              link +
              "\n" +
              "\n" +
              org +
              "\n" +
              "\n" +
              seeyou +
              "\n" +
              "\n"
          );
          this.shareurl = `https://api.whatsapp.com/send?text=${message}`;

          if (element.value == res.courttype) {
            this.courttype = element.label;
          }
        });

        this.academyPic = res.academyPic;
        this.academyId = res.academyId;
        if (
          this.isLoggedIn == true &&
          this.academyId == this.loggedInUser.userdata.academyId
        ) {
          //this.router.navigate(["tournaments/factsheet/" + this.tournamentId]);
          this.ownlink = true;
        } else {
          //this.router.navigate(["tournament-draw-view/" + this.tournamentId]);
          this.ownlink = false;
        }
        //let currentdate = new Date();
        let currentdate = moment();

        if (
          moment(this.lastdateofregistration.replace('Z', '')).isSameOrBefore(currentdate)
        ) {
          this.showRegisterButton = true;
          this.outdate_reg_status = true;
        } else {
          this.showRegisterButton = true;
          this.outdate_reg_status = false;
        }

        if (
          moment(this.lastdateofwithdraw.replace('Z', '')).isSameOrBefore(currentdate)
        ) {
          this.outdate_withdraw_status = true;
        } else {
          this.outdate_withdraw_status = false;
        }
      });
  }

  onclickAcademydetails() {
    this.router.navigate(["academies/academydetails/" + this.academyId]);
  }

  shareFacebook() {
    const url =
      "https://www.facebook.com/sharer/sharer.php?u=" +
      encodeURIComponent(window.location.href);
    window.open(url, "_blank");
  }

  shareTwitter() {
    const text = "Check out this awesome content!";
    const url =
      "https://twitter.com/intent/tweet?text=" +
      encodeURIComponent(text) +
      "&url=" +
      encodeURIComponent(window.location.href);
    window.open(url, "_blank");
  }
  shareWhatsApp() {
    const heading = "*🎾 Exciting Tennis Tournament Alert! 🎾* ";
    const subheading = "Hey Tennis Enthusiasts! ";
    const titleparagraph =
      "We are thrilled to announce the " +
      this.tournamentname +
      " happening on " +
      moment(this.startdate).format("DD-MM-YYYY") +
      " at " +
      this.cityname +
      ". 🏆 ";
    const lastdate =
      "*🗓️ Last Date Of Registration: " +
      moment(this.lastdateofregistration).format("DD-MM-YYYY") +
      "*";
    const startdate =
      "*🗓️ Tournament Start Date: " +
      moment(this.startdate).format("DD-MM-YYYY") +
      "*";
    const Tend =
      "*🗓️ Tournament End Date: " +
      moment(this.enddate).format("DD-MM-YYYY") +
      "*";
    const Wd =
      "*🕒 Withdrawal Date: " +
      moment(this.lastdateofwithdraw).format("DD-MM-YYYY") +
      "*";
    const location =
      "*📍 Location: " +
      this.address +
      ", " +
      this.cityname +
      ", " +
      this.statename +
      ", " +
      this.zipcode +
      "*";
    const bottommsg =
      "Whether you're a seasoned player or just starting out, this tournament is the perfect opportunity to showcase your skills and have a blast on the court. It's all about friendly competition and the love of the game! 🎾💥";
    const heiglishheading = "*Tournament Highlights:*";
    //const cat = 'Categories : [All categories Name]';
    //const currentPageLink = window.location.href;
    const currentPageLink =
      "*" +
      "https://www.tplsport.com/tournaments/factsheet/" +
      this.tournamentId +
      "*";
    const link =
      "Don't miss your chance to be part of the action! To register or learn more, visit ";
    const pagelink = "*" + currentPageLink + "*";

    const org =
      "For inquiries, contact " +
      this.academyName +
      " at " +
      this.organizercontactnumber +
      ".";
    const text =
      "Let's hit the court together and make this tournament an unforgettable experience! 🎾🏆";
    const seeyou = "See you on the courts!";
    const phoneNumber = "1234567890"; // Replace with the recipient's phone number

    const siteIconUrl = "https://www.tplsport.com/favicon.ico"; // Replace with your site's icon URL

    // Construct the WhatsApp sharing URL
    const message = encodeURIComponent(
      heading +
        "\n" +
        "\n" +
        subheading +
        "\n" +
        "\n" +
        titleparagraph +
        "\n" +
        "\n" +
        lastdate +
        "\n" +
        "\n" +
        startdate +
        "\n" +
        "\n" +
        Tend +
        "\n" +
        "\n" +
        Wd +
        "\n" +
        "\n" +
        location +
        "\n" +
        "\n" +
        "\n" +
        bottommsg +
        "\n" +
        "\n" +
        heiglishheading +
        "\n" +
        "\n" +
        link +
        "\n" +
        pagelink +
        "\n" +
        "\n" +
        org +
        "\n" +
        text +
        "\n" +
        "\n" +
        seeyou +
        "\n" +
        "\n"
    );
    this.shareurl = `https://api.whatsapp.com/send?text=${message}&link=${currentPageLink}&image=${siteIconUrl}`;
  }
  onClicktournamentPlayerList() {
    this.router.navigate([`player-list/${this.tournamentId}`]);
  }

  loadTournament(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query = "?filterByDisable=false&filterByStatus=true";
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    if (this.academyId != null) {
      query += "&filterByAcademyId=" + this.academyId;
    }
    // query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    this.tournamentsService.getTournamentsListWithoutAuth(query).subscribe(
      (data) => {
        //console.log("tournamentList Data",data);
        this.loading = false;
        this.tournamentList = data.data.items;

        // for (const tournament of this.tournamentList) {
        //   const lastDateOfRegistration = tournament.lastdateofregistration;
        //   console.log("list lastDateOfRegistration: ",lastDateOfRegistration);
        //   console.log("list currentDate: ",this.currentDate);

        //   if (
        //     moment(this.currentDate).format("YYYY-MM-DD") >
        //     moment(lastDateOfRegistration).format("YYYY-MM-DD")
        //   ) {
        //     this.outdate_reg_status = true;
        //   } else {
        //     this.outdate_reg_status = false;
        //   }
        //   console.log("list outdate_reg_status: ",this.outdate_reg_status);
        //   //console.log("Last Date of Registration:", lastDateOfRegistration);
        // }

        this.totalRecords = data.data.totalCount;
        this.tournamentList.forEach((element) => {
          this.imagedataa = element["academyPic"];
          let tmp = this.courtTypeList.find(
            (o) => o.value === element.courttype
          );
          if (tmp != undefined) {
            element.court = tmp.label;
          } else {
            element.court = "";
          }
          if (element["cityname"] == "Pune") {
            element["showPmdtaNumber"] = true;
          } else {
            element["showPmdtaNumber"] = false;
          }
        });
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  viewMoreCategoriesToggleOption(tournament) {
    tournament.isViewMore = !tournament.isViewMore;
  }
  
  pointsDataNameCheckFunc(tournament) {
    if (tournament) {
      let isPoinstDataNamesAvailable = Object.keys(tournament).includes('pointsDataName');
      return isPoinstDataNamesAvailable;
    }
    return null;
  }

  matchDataNameCheckFunc(tournament) {
    let isMatchDataNamesAvailable = Object.keys(tournament).includes('matchDataName');
    return isMatchDataNamesAvailable;
  }

  getTournamentCategoryData(id) {
    this.tournamentsService.getTournamentscat(id).subscribe(
      (response) => {
        this.tourcatList = response.items;
        // Prepend the "Select" option to the list
        this.tourcatList.unshift({ matchTypeId: "", matchTypeName: "Select" });
      },
      (error) => {
        // console.error("Error fetching data:", error);
      }
    );
  }
  Withdrawclose(): void {
    this.WithdrawModal = false;
    this.renderer.removeClass(document.body, "p-overflow-hidden");
  }
  showloginDialog(id) {
    this.tournamentId = id;
    //console.log("TournamentId - ", this.tournamentId);

    const matchingTournament = this.tournamentList.find(
      (tournament) => tournament.id === this.tournamentId
    );
    if (matchingTournament) {
      this.tournamentname = matchingTournament.name;
      this.selectedTournamentCityName = matchingTournament.citycode;
    } else {
      //return;
    }

    if (this.selectedTournamentCityName == "Pune") {
      this.showPmdtaNumber = true;
    } else {
      this.showPmdtaNumber = false;
    }

    if (Object.keys(this.loggedInUser).length === 0) {
      this.router.navigate(['/']);
      return;
    }
    if (this.isLoggedIn) {
      //console.log("I am here - ");
      if (this.loggedInUser.userdata.isProfileComplete === false) {
        // let currentUrl = "/profile-edit";
        // this.router.onSameUrlNavigation = "reload";
        // this.router.navigate([currentUrl]);
        this.welcomeLogin = true;
        return;
      }
      this.TournamentEntry = true;
      this.getTournamentCategoryData(this.tournamentId);
      this.getTournamentCategoryV2(this.tournamentId);
      this.fieldsFormArray.clear();
      this.selectedEntryFees = [];
      this.selectedCategoryAndAgeGroupList = [];
      this.disableCategories = [];
      this.subAgegroup = [];
      this.addField();
    } else {
      this.visible = true;
    }
  }

  async getTournamentCategoryV2(id) {
    this.tournamentService.getTournamentCategoryV2(id).subscribe(
      data => {
        if (data) {
            const categoryAndAgeGroupList = data['items'].reduce((tournamentCategories,category) => {
              tournamentCategories.push(...category.ageGroups);
              return tournamentCategories;
            },[]);
            if (this.registeredtournamentdata.length !== 0) {
              this.registeredtournamentdata.forEach(withdrawCategory => {
                const index = categoryAndAgeGroupList.findIndex(category => category.matchTypeId === withdrawCategory['matchTypeId'] && category.ageGroupId === withdrawCategory['ageGroupId']);
                if (index !== -1) {
                  categoryAndAgeGroupList.splice(index,1);
                }
              })
            }
            this.originalCategoryAndAgeGroupList = JSON.parse(JSON.stringify(categoryAndAgeGroupList));
            this.categoryAndAgeGroupList = categoryAndAgeGroupList;
            this.registrationCategoryErrorMessage = null;

            this.categoryAndAgeGroupList.unshift({
              categoryName: "Select",
              matchTypeId: null,
              ageGroupId: null,
              value: null,
              entryFee: 0,
              maxPlayer: 0,
              tournamentCategoryId: null,
            });
            this.refreshCategoryLists();
            this.showNoCategories = !this.hasSelectableCategories;
        }
      },
      (err) => {
      }
    );
  }

  private toCategoryCount(value: any): number | null {
    if (value === null || value === undefined || value === '') { return null; }
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }

  isCategoryFull(category: any): boolean {
    if (!category) { return false; }
    const maxPlayer = this.toCategoryCount(category.maxPlayer);
    const playerCount = this.toCategoryCount(
      category.playercount ?? category.playerCount ?? category.currentCount
    );
    if (maxPlayer === null || playerCount === null || maxPlayer <= 0) { return false; }
    return playerCount >= maxPlayer;
  }

  refreshCategoryLists(): void {
    const list = this.categoryAndAgeGroupList || [];
    this.selectableCategoryList = list.filter(category => !this.isCategoryFull(category));
    this.fullCategoryList = list.filter(category => this.isCategoryFull(category));
  }

  get fullCategoryNames(): string {
    return this.fullCategoryList
      .map(category => category.categoryName || category.CategoryName)
      .filter(name => !!name)
      .join(', ');
  }

  get hasSelectableCategories(): boolean {
    return this.selectableCategoryList.some(category => category.matchTypeId && category.ageGroupId);
  }

  get hasFullSelectedCategory(): boolean {
    return (this.fieldsFormArray?.controls || []).some(
      (control: any) => this.isCategoryFull(control.get('categories')?.value)
    );
  }

  private isRealTournamentCategory(category: any): boolean {
    return !!(category && category.matchTypeId && category.ageGroupId);
  }

  private getCategoryKey(category: any): string {
    if (!category) { return ''; }
    return (
      category._id ||
      category.tournamentCategoryId ||
      category.id ||
      `${category.matchTypeId || ''}_${category.ageGroupId || ''}`
    ).toString();
  }

  private getCategoryDisplayName(category: any): string {
    if (!category) { return ''; }
    return category.categoryName || category.CategoryName || `${category.matchTypeName || ''} - ${category.ageGroupName || ''}`.trim();
  }

  private getCategoryDropdownSource(): any[] {
    const source = Array.isArray(this.originalCategoryAndAgeGroupList) && this.originalCategoryAndAgeGroupList.length
      ? this.originalCategoryAndAgeGroupList
      : (this.categoryAndAgeGroupList || []);
    return source.filter(category => this.isRealTournamentCategory(category));
  }

  private getSelectedCategoryKeysExcept(index: number): string[] {
    return (this.fieldsFormArray?.controls || [])
      .map((control: any, controlIndex: number) => controlIndex !== index ? this.getCategoryKey(control.get('categories')?.value) : '')
      .filter(key => !!key);
  }

  getSelectableCategoriesForField(index: number): any[] {
    const selectedInOtherFields = this.getSelectedCategoryKeysExcept(index);
    const currentCategory = this.fieldsFormArray?.controls[index]?.get('categories')?.value;
    const currentCategoryKey = this.getCategoryKey(currentCategory);
    const placeholder = (this.categoryAndAgeGroupList || []).find(category => !this.isRealTournamentCategory(category)) || {
      categoryName: "Select",
      matchTypeId: null,
      ageGroupId: null,
      value: null,
      entryFee: 0,
      maxPlayer: 0,
      tournamentCategoryId: null,
    };

    const selectableCategories = this.getCategoryDropdownSource().filter(category => {
      const categoryKey = this.getCategoryKey(category);
      const isCurrentCategory = currentCategoryKey && categoryKey === currentCategoryKey;
      return (isCurrentCategory || !selectedInOtherFields.includes(categoryKey)) && !this.isCategoryFull(category);
    });

    return [placeholder, ...selectableCategories];
  }

  getFullCategoryNamesForField(index: number): string {
    const selectedInOtherFields = this.getSelectedCategoryKeysExcept(index);

    return this.getCategoryDropdownSource()
      .filter(category => !selectedInOtherFields.includes(this.getCategoryKey(category)) && this.isCategoryFull(category))
      .map(category => this.getCategoryDisplayName(category))
      .filter(name => !!name)
      .join(', ');
  }

  get hasAnyTournamentCategory(): boolean {
    return this.getCategoryDropdownSource().length > 0;
  }

  get hasAddableCategories(): boolean {
    const selectedKeys = (this.fieldsFormArray?.controls || [])
      .map((control: any) => this.getCategoryKey(control.get('categories')?.value))
      .filter(key => !!key);

    return this.getCategoryDropdownSource().some(category => {
      const categoryKey = this.getCategoryKey(category);
      return !selectedKeys.includes(categoryKey) && !this.isCategoryFull(category);
    });
  }

  private getRegistrationCategoryErrorMessage(error: any): string {
    const message = error?.error?.message || error?.message || '';
    return message || 'Selected category is full. Please choose another category.';
  }

  hideWelcomeLoginDialog() {
    this.welcomeLogin = false;
  }

  catageclose(): void {
    this.TournamentEntry = false;
    this.termsAndConditions = false;
    this.renderer.removeClass(document.body, "p-overflow-hidden");
  }

  get fieldsFormArray() {
    return this.myForm.get("fields") as FormArray;
  }
  // Method to add a new form group (field) to the form array
  createFieldGroup() {
    return this.fb.group({
      matchTypeId: ["", Validators.required],
      ageGroupId: ["", Validators.required],
      categories: ["", Validators.required],
      // pmdtaNumber: ["", Validators.pattern("^[A-Za-z0-9 '][A-Za-z0-9 ']*$")],
      // doublePlayerPmdtaNumber: [
      //   "",
      //   Validators.pattern("^[A-Za-z0-9 '][A-Za-z0-9 ']*$"),
      // ],
      doublePlayerId: [""],
      doubleUserEmail: [""],
      entryFee: [0],
      maxPlayer: [],
      tournamentCategoryId: [],
    });
  }
  addField() {
    if (this.fieldsFormArray.length > 0) {
      let matchTypeIdValue = this.fieldsFormArray.controls[this.fieldsFormArray.length - 1]['controls']['matchTypeId'].value;
      let ageGroupIdValue = this.fieldsFormArray.controls[this.fieldsFormArray.length - 1]['controls']['ageGroupId'].value;
      if (matchTypeIdValue && ageGroupIdValue) {
        let index = this.categoryAndAgeGroupList.findIndex(({ matchTypeId, ageGroupId }) => (matchTypeId === matchTypeIdValue && ageGroupId === ageGroupIdValue));
        this.disableCategories[this.fieldsFormArray.length - 1] = true;
        if (index !== -1) {
          this.selectedCategoryAndAgeGroupList.push(this.categoryAndAgeGroupList.find(({ matchTypeId, ageGroupId }) => (matchTypeId === matchTypeIdValue && ageGroupId === ageGroupIdValue)));
          this.categoryAndAgeGroupList.splice(index,1);
        }
      }
    }
    this.fieldsFormArray.push(this.createFieldGroup());
    if (this.fieldsFormArray.length > 1) {
      this.disableCategories[0] = true;
    }
    this.disableCategories.push(false);
    this.calculateTotalEntryFee();
    this.totalleftCash = this.walletBalance - this.totalEntryFee();
    this.isFieldAdded = true;
    this.resetDoublesPartnerSection();
    this.isTournamentCatgeorySelected = false;
    //console.log(this.selectedTournamentCityName);

    if (this.selectedTournamentCityName == "Pune") {
      this.showPmdtaNumber = true;
    } else {
      this.showPmdtaNumber = false;
    }
    this.refreshCategoryLists();
  }
  resetDoublesPartnerSection() {
    this.showDoublesPartnerSection = false;
  }
  // Method to remove a specific form group (field) from the form array
  removeField(index: number) {
    let matchTypeIdValue = this.fieldsFormArray.controls[index]['controls']['matchTypeId'].value;
    let ageGroupIdValue = this.fieldsFormArray.controls[index]['controls']['ageGroupId'].value;
    this.fieldsFormArray.removeAt(index);
    this.isTournamentCatgeorySelected = this.fieldsFormArray.value.every(ele => ele.matchTypeId !== '');
    if (matchTypeIdValue && ageGroupIdValue) {
      let selectedIndex = this.selectedCategoryAndAgeGroupList.findIndex(({ matchTypeId, ageGroupId }) => (matchTypeId === matchTypeIdValue && ageGroupId === ageGroupIdValue));
      this.categoryAndAgeGroupList.push(this.selectedCategoryAndAgeGroupList.find(({ matchTypeId, ageGroupId }) => (matchTypeId === matchTypeIdValue && ageGroupId === ageGroupIdValue)));
      this.selectedCategoryAndAgeGroupList.splice(selectedIndex,1);
    }
    this.disableCategories.splice(index, 1);
    if (this.fieldsFormArray.length === 1) {
      this.categoryAndAgeGroupList.push(...this.selectedCategoryAndAgeGroupList);
      this.selectedCategoryAndAgeGroupList = [];
      this.disableCategories[0] = false;
    }
    this.selectedEntryFees.splice(index, 1); // Remove the corresponding entry fee from the array
    this.calculateTotalEntryFee(); // Recalculate the total entry fee
    this.totalleftCash = this.walletBalance - this.totalEntryFee(); // Recalculate totalleftCash
    this.refreshCategoryLists();
  }
  
  onTournamentCategorySelect(event, index) {
    if (this.isCategoryFull(event.value)) {
      this.registrationCategoryErrorMessage = `${event.value.categoryName} - Category is Full`;
      this.errorMessage = this.registrationCategoryErrorMessage;
      this.myForm.controls['fields']['controls'][index]['controls']['categories'].setValue(null);
      return;
    }
    this.registrationCategoryErrorMessage = null;
    const selectedMatchType = event.value.matchTypeId;
    this.isTournamentCatgeorySelected = (!selectedMatchType) ? false : true;
    this.myForm.controls['fields']['controls'][index]['controls']['matchTypeId'].setValue(event.value.matchTypeId);
    this.myForm.controls['fields']['controls'][index]['controls']['ageGroupId'].setValue(event.value.ageGroupId);

    const doubleUserEmailControl =
    this.fieldsFormArray.controls[index].get("doubleUserEmail");

  if (this.doublecatarray.includes(selectedMatchType)) {
    this.elementRef.nativeElement.querySelector(
      "#add_double_partner_" + index
    ).style.display = "block";
    doubleUserEmailControl.setValidators(Validators.required);


  } else {
    this.myForm.value.fields[index].doublePlayerId = "";
    this.myForm.value.fields[index].doubleUserEmail = "";
    this.elementRef.nativeElement.querySelector(
      "#add_double_partner_" + index
    ).style.display = "none";
    this.elementRef.nativeElement.querySelector(
      "#double_partner_" + index
    ).style.display = "none";
    doubleUserEmailControl.clearValidators();

  }

  doubleUserEmailControl.updateValueAndValidity();

  const selectedAgeGroup = event.value.ageGroupId;
    this.selectedAgeGroups[index] = selectedAgeGroup;
    this.selectedAgeGroupIndices[index] = index;
    // Check if subAgegroup for the specific index exists and is not undefined
    if (
      this.categoryAndAgeGroupList &&
      Array.isArray(this.categoryAndAgeGroupList) &&
      this.categoryAndAgeGroupList.length > 0
    ) {
      if (event.value.entryFee) {
        this.selectedEntryFee = event.value.entryFee;
      } else {
        this.selectedEntryFee = 0;
      }
      this.myForm.value.fields[index].entryFee = event.value.entryFee;
      this.myForm.value.fields[index].maxPlayer =
        event.value.maxPlayer;
      this.myForm.value.fields[index].tournamentCategoryId =
        event.value._id;
      if (event.value.entryFee) {
        this.selectedEntryFees[index] = event.value.entryFee;
      } else {
        this.selectedEntryFees[index] = 0;
      }

      this.calculateTotalEntryFee();
      this.myForm.controls["fields"]["controls"][index]
        .get("entryFee")
        .setValue(event.value.entryFee);
      this.myForm.controls["fields"]["controls"][index]
        .get("tournamentCategoryId")
        .setValue(event.value._id);
      this.myForm.controls["fields"]["controls"][index]
        .get("maxPlayer")
        .setValue(event.value.maxPlayer);
    } else {
      this.selectedEntryFee = 0; // Set a default value if the subAgegroup data is empty or undefined
    }
  }

  /** OTP login start */
  onOtpChange(otp) {
    this.otp = otp;
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
  }
  onClickOtpSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    }
    let otpData = {
      otp: this.otp,
      mobileNumber: this.mobileNumber,
    };
    this.authService.verifyOtp(otpData).subscribe(
      (data) => {
        this.router.navigate(["/thankyou"]);
      },
      (err) => {
        this.showOtpErrorsMsg = true;
        this.otpErrorMessage = err.error.error;
        setTimeout(() => {
          this.showOtpErrorsMsg = false;
        }, 5000);
      }
    );
  }
  onForgotPassSubmit() {
    this.submitted = true;
    if (this.forgotPassForm.valid) {
      this.authService.requestPassword(this.forgotPassForm.value).subscribe(
        (res) => {
          if (res["errors"]) {
            this.errorMessage = res["errors"];
            this.successMessage = "";
          } else {
            this.successMessage = res;
            this.errorMessage = "";
          }
          this.showMessage = true;
          setTimeout(() => {
            this.submitted = false;
            this.forgotPassForm.reset();
            this.showMessage = false;
            this.successMessage = "";
          }, 2000);
        },
        (err) => {
          this.successMessage = "";
          this.showMessage = true;
          this.errorMessage = err.error.data.errors;
        }
      );
    }
  }
  onMobilePhoneSubmit(mode) {
    let mobileData;
    if (mode != "resend") {
      this.submitted = true;
      //stop here if form is invalid
      if (this.mobileLoginForm.invalid) {
        return;
      }

      mobileData = this.mobileLoginForm.value.mobileNumber;
      this.mobileNumber = mobileData;
    } else {
      mobileData = this.mobileNumber;
    }

    this.authService.generateMobileOtp(mobileData).subscribe(
      (res) => {
        this.showMobileLoginOtpForm = true;
        this.showResendButton = false;
        //this.timer(5);
        this.counter = 300;
        this.tick = 1000;
        this.otpTimer(this.counter, this.tick);
      },
      (err) => {
        this.showMobileFormErrors = true;
        this.mobileFormsErrors = err.error.error;
        setTimeout(() => {
          this.showMobileFormErrors = false;
        }, 5000);
        this.showMobileLoginOtpForm = false;
      }
    );
  }

  onClickOtpback() {
    this.showMobileLoginOtpForm = false;
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
    this.countDown.unsubscribe();
  }
  resendOtp() {
    let mode = "resend";
    //console.log("Resend part");
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
    this.otp = "";
    this.ngOtpInput.setValue(0);
    this.onMobilePhoneSubmit(mode);
  }
  onClickOtpLoginSubmit() {
    //console.log("I am");
    if (this.otp == undefined || this.otp == "" || this.otp.length < 6) {
      this.showOtpErrors = true;
      this.showOtpLoginErrors = false;
      return;
    }
    let otpData = {
      otp: this.otp,
      mobileNumber: this.mobileNumber,
    };
    this.authService.otpLogin(otpData).subscribe(
      (data) => {
        //console.log("OTP data", data);
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        this.getParentCategory();
        let currentUrl = "tournaments/factsheet/" + this.tournamentId;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        this.router.navigate([currentUrl]);
      },
      (err) => {
        // console.log(err, "error");
        this.showOtpLoginErrors = true;
        this.otpLoginErrors = err.error.error;
      }
    );
  }
  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.displayTime = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        clearInterval(timer);
        this.showResendButton = true;
      }
    }, 1000);
    if (minute == 0) {
      this.displayTime = 0;
      clearInterval(timer);
    }
  }
  otpTimer(counter, tick) {
    this.countDown = timer(0, this.tick)
      .pipe(take(this.counter))
      .subscribe(() => {
        --this.counter;
        if (this.counter == 0) {
          this.showResendButton = true;
          this.countDown.unsubscribe();
        }
      });
  }
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ("00" + minutes).slice(-2) +
      ":" +
      ("00" + Math.floor(value - minutes * 60)).slice(-2)
    );
  }

  /** OTP login End */

  onSubmit(): void {
    this.loginFormSubmitted = true;
    //stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    const username = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    this.userType = "player";

    this.authService.login(username, password, this.userType, false).subscribe(
      (data) => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getParentCategory();

        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // this.route.navigate(["tournaments/factsheet/" + id]);
        let currentUrl = "tournaments/factsheet/" + this.tournamentId;
        if (this.userData.data.userdata.isProfileComplete === false) {
          currentUrl = "/profile-edit";
        }
        this.router.onSameUrlNavigation = "reload";
        this.router.navigate([currentUrl]);
      },
      (error) => {
        //throw Error();
        this.loginFormSubmitted = false;
        this.errorMessage =
          "Login failed: Please check your login credentials...! ";

        this.isLoginFailed = true;
      }
    );
    //});

    // this.getTournamentCategoryData();
  }

  getParentCategory() {
    var query = "?filterByDisable=false&filterByStatus=true&getOnlyParent=true";
    this.categoryService.getCategoryList(query).subscribe(
      (data) => {
        this.parentcatList = data.data.items;
        this.tokenStorage.saveCategorylist(this.parentcatList);
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  onCashSubmit(event: Event) {
    this.Walletdialog = true;
    event.preventDefault();
    this.added_amount = this.addCashForm.value.amount;
    this.submitted = true;
    if (this.addCashForm.invalid) {
      return;
    }
    var addCashData = this.addCashForm.value;
    addCashData["walletType"] = "CASH";
    //console.log("addCashData:-",addCashData);
    addCashData["userId"] = this.loggedInUser.userdata.id;

    if (addCashData["amount"] > 0) {
      this.Addcashmodal = false;
      addCashData = JSON.stringify(addCashData, null, 4);
      const amt = addCashData["amount"];
      this.walletpaymentService
        .addWalletPayment(addCashData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCashForm.value.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Cash to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = async (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.loggedInUser.userdata.id,
              walletType: "CASH",
              amount: this.addCashForm.value.amount,
            };
            //commented below code as verify will be done by webhook
            // call your backend api to verify payment signature & capture transaction
            // this.walletpaymentService
            //   .verifyWalletpayment(verifyPaymentData)
            //   .subscribe((paymentdata) => {
            //     // this.walletBalance += this.added_amount;
            //     //this.totalleftCash = this.walletBalance - this.totalEntryFee();
            //     this.getUserBalance();
            //   });
            await this.getUserBalance();
            this.thankYouMsg = true;

            setTimeout(() => {
              this.hideDiv();
              this.thankyouModal();
            }, 1000); // Hide the div after 1000 milliseconds (1 seconds)
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        });
    }
  }

  async getUserBalance() {
    if (this.isLoggedIn) {
      var query =
        "?filterByDisable=false&filterByUserid=" +
        this.loggedInUser.userdata.id;
      this.userWalletService.getUserWalletList(query).subscribe(
        (data) => {
          //console.log("data : ", data);
          this.walletBalance =
            data.data.totalCash - data.data.totalDeductedCash;
          this.totalCash = data.data.totalCash;
          //this.totalCoins = data.data.totalCoins;
          if (this.walletBalance > this.totalEntryFee()) {
            //console.log("greater");
            this.onRadioClick();
            this.isRegisterButtonEnabled();
          } else {
            //console.log("not greater");
          }
          if (this.thankYouMsg === true) {
            this.totalleftCash = this.walletBalance - this.totalEntryFee();
          }
          this.cdr.detectChanges();
        },
        (err) => {
          this.errorMessage = err.error.message;
        }
      );
    }
  }
  get f() {
    return this.signUpForm.controls;
  }
  get a() {
    return this.addCashForm.controls;
  }
  get loginf() {
    return this.loginForm.controls;
  }
  get forgotPassValidation() {
    return this.forgotPassForm.controls;
  }
  get mobNumberFormValidation() {
    return this.mobileLoginForm.controls;
  }
  getRoleDetails() {
    const querystring = "filterByroleId=" + this.userData.data.userdata.role;
    this.roleService.getRoleListWithoutAuth(querystring).subscribe(
      (data) => {
        this.trainerRoleId = data.data.items[0]["id"];
        this.permissions = data.data.items[0]["permissions"];
        this.tokenStorage.saveUserPermissions(this.permissions);
        this.rolelist = data.data.items[0];
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getRoleList() {
    var querystring = "filterByDisable=false&filterByStatus=true";
    var rolearray = [];
    this.roleService.getRoleListWithoutAuth(querystring).subscribe(
      (data) => {
        var rolelist = data.data.items;
        rolelist.forEach((element) => {
          rolearray.push({
            roleid: element.id,
            rolename: element.user_role_name,
          });
        });
        if (rolearray.length > 0) {
          this.tokenStorage.saveRolelist(rolearray);
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  /*
  addCategorform() {
    this.categorysectionform().push(this.newcategorysection());
  }*/

  getCategory() {
    var query =
      "?filterByDisable=false&filterByStatus=true&filterBySlug=tournament_junior_agegroup&sortBy=created_at&orderBy=1";
    this.categoryService.getCategoryWithoutAuthList(query).subscribe((data) => {
      var query =
        "?filterByDisable=false&filterByStatus=true&filterByParent=" +
        data.data.items[0]["id"] +
        "&sortBy=created_at&orderBy=1";
      this.categoryService.getCategoryDetailsWithoutAuthList(query).subscribe(
        (data) => {
          var catlist = data.data.items;
          catlist.forEach((element) => {
            let obj = {
              label: element.name,
              value: element.id,
              slug: element.slug,
            };
            this.agecatlist.push(obj);
          });
          var query =
            "?filterByDisable=false&filterByStatus=true&filterBySlug=tournament_senior_agegroup&sortBy=created_at&orderBy=1";
          this.categoryService
            .getCategoryWithoutAuthList(query)
            .subscribe((data) => {
              var query =
                "?filterByDisable=false&filterByStatus=true&filterByParent=" +
                data.data.items[0]["id"] +
                "&sortBy=created_at&orderBy=1";
              this.categoryService
                .getCategoryDetailsWithoutAuthList(query)
                .subscribe(
                  (data) => {
                    var catlist = data.data.items;
                    catlist.forEach((element) => {
                      let obj = {
                        label: element.name,
                        value: element.id,
                        slug: element.slug,
                      };
                      this.agecatlist.push(obj);
                    });
                  },
                  (err) => {
                    this.errorMessage = err.error.message;
                  }
                );
            });
        },
        (err) => {
          this.errorMessage = err.error.message;
        }
      );
    });
  }

  updateConfirmButtonState() {
    //console.log("Updating button state...");
    for (const fieldGroup of this.fieldsFormArray.controls) {
      const matchTypeId = fieldGroup.get("matchTypeId").value;
      const ageGroupId = fieldGroup.get("ageGroupId").value;

      if (!matchTypeId || !ageGroupId) {
        this.isConfirmButtonDisabled = true;
        return;
      }
    }

    // If all fields have values, enable the button
    this.isConfirmButtonDisabled = false;
  }

  /**Age Part */
  onMatchSelect(event: any, index: number) {
    console.log(index, "match index");
    const selectedMatchType = event.value;
    // if (this.selectedTournamentCityName == "Pune") {              - start hide pmdta
    //   this.showDoublePmdtaNumber = true;
    // } else {
    //   this.showDoublePmdtaNumber = false;
    // }                                                             - exit hide pmdta
    // this.doublecatarray = [
    //   "64cc7362c58c8c8cbc0e79ee",
    //   "64cc7362c58c8c8cbc0e79f0",
    //   "64cc7362c58c8c8cbc0e79f2",
    //   "64cc7362c58c8c8cbc0e79f4",
    //   "64cc7362c58c8c8cbc0e79f5",
    // ];
    // Get the form control for doubleUserEmail
    const doubleUserEmailControl =
    this.fieldsFormArray.controls[index].get("doubleUserEmail");

  // const doublePlayerPmdtaNumberControl = this.myForm.controls["fields"][                - start hide pmdta
  //   "controls"
  // ][index].get("doublePlayerPmdtaNumber");                                              - exit hide pmdta
  if (this.doublecatarray.includes(selectedMatchType)) {
    this.elementRef.nativeElement.querySelector(
      "#double_partner_" + index
    ).style.display = "block";
    doubleUserEmailControl.setValidators(Validators.required);
    // if (this.showDoublePmdtaNumber === false) {                               - start hide pmdta
    //   this.diableConfirmButton = false;
    //   doublePlayerPmdtaNumberControl.clearValidators();
    // } else {
    //   this.diableConfirmButton = true;
    //   doublePlayerPmdtaNumberControl.setValidators([
    //     Validators.required,
    //     Validators.pattern("^[A-Za-z0-9 '][A-Za-z0-9 ']*$"),
    //   ]);
    // }                                                                          - exit hide pmdta


  } else {
    this.myForm.value.fields[index].doublePlayerId = "";
    this.myForm.value.fields[index].doubleUserEmail = "";
    // this.myForm.value.fields[index].doublePlayerPmdtaNumber = "";             - start hide pmdta
    // this.myForm.value.fields[index].pmdtaNumber = "";                         - exit hide pmdta
    this.elementRef.nativeElement.querySelector(
      "#double_partner_" + index
    ).style.display = "none";
    doubleUserEmailControl.clearValidators();

  }
    
  doubleUserEmailControl.updateValueAndValidity();

    let obj = this.tourcatList.find((o) => o.matchTypeId === selectedMatchType);
    let tournamentCategoryId = obj.tournamentCategoryId;

    if (selectedMatchType) {
      this.tournamentsService
        .getCatbasedAge(
          this.tournamentId,
          selectedMatchType,
          tournamentCategoryId
        )
        .subscribe((data) => {
          const originalXxx = data.items;
          this.matchCheckingArray = this.fieldsFormArray.value.concat(
            this.registeredtournamentdata
          );
          this.matchCheckingArray.forEach((a1) =>
            originalXxx.forEach((a2) => {
              if (
                a1.matchTypeId == a2.matchTypeId &&
                a1.ageGroupId == a2.ageGroupId
              ) {
                originalXxx.splice(
                  originalXxx.findIndex(
                    ({ ageGroupId }) => ageGroupId == a1.ageGroupId
                  ),
                  1
                );
              }
            })
          );

          if (originalXxx.length > 0) {
            this.subAgegroup[index] = originalXxx.map((item) => ({
              label: item.ageGroupName,
              value: item.ageGroupId,
              entryFee: item.entryFee,
              maxPlayer: item.maxPlayer,
              tournamentCategoryId: item.tournamentCategoryId,
            }));

            // Prepend a blank option to the subAgegroup data
            this.subAgegroup[index].unshift({
              label: "Select",
              value: null,
              entryFee: 0,
              maxPlayer: 0,
              tournamentCategoryId: null,
            });
          }
        });
    } else {
      this.subAgegroup[index] = [
        {
          label: "Select",
          value: null,
          entryFee: 0,
          maxPlayer: 0,
          tournamentCategoryId: null,
        },
      ]; // Add a blank option when no match type is selected
    }
    // console.log(this.myForm.controls["fields"]["controls"][index]);
  }

  onAgeGroupSelect(event: any, index: number) {
    const selectedAgeGroup = event.value;

    this.selectedAgeGroups[index] = selectedAgeGroup;
    this.selectedAgeGroupIndices[index] = index;

    // Check if subAgegroup for the specific index exists and is not undefined
    if (
      this.subAgegroup[index] &&
      Array.isArray(this.subAgegroup[index]) &&
      this.subAgegroup[index].length > 0
    ) {
      const selectedAgeGroupData = this.subAgegroup[index].find(
        (ageGroup) => ageGroup.value === selectedAgeGroup
      );
      if (selectedAgeGroupData) {
        this.selectedEntryFee = selectedAgeGroupData.entryFee;
      } else {
        this.selectedEntryFee = 0;
      }

      this.myForm.value.fields[index].entryFee = selectedAgeGroupData.entryFee;
      this.myForm.value.fields[index].maxPlayer =
        selectedAgeGroupData.maxPlayer;
      this.myForm.value.fields[index].tournamentCategoryId =
        selectedAgeGroupData.tournamentCategoryId;
      if (selectedAgeGroupData) {
        this.selectedEntryFees[index] = selectedAgeGroupData.entryFee;
      } else {
        this.selectedEntryFees[index] = 0;
      }

      this.calculateTotalEntryFee();
      this.myForm.controls["fields"]["controls"][index]
        .get("entryFee")
        .setValue(selectedAgeGroupData.entryFee);
      this.myForm.controls["fields"]["controls"][index]
        .get("tournamentCategoryId")
        .setValue(selectedAgeGroupData.tournamentCategoryId);
      this.myForm.controls["fields"]["controls"][index]
        .get("maxPlayer")
        .setValue(selectedAgeGroupData.maxPlayer);
    } else {
      this.selectedEntryFee = 0; // Set a default value if the subAgegroup data is empty or undefined
    }
    this.refreshCategoryLists();

    // if (this.showPmdtaNumber === false) {
    //   this.diableConfirmButton = false;
    //   this.myForm.controls["fields"]["controls"][index]
    //     .get("pmdtaNumber")
    //     .clearValidators();
    // } else {
    //   this.diableConfirmButton = true;
    //   this.myForm.controls["fields"]["controls"][index]
    //     .get("pmdtaNumber")
    //     .setValidators([
    //       Validators.required,
    //       Validators.pattern("^[A-Za-z0-9 '][A-Za-z0-9 ']*$"),
    //     ]);
    //   // console.log(this.myForm);
    //   this.myForm.controls["fields"]["controls"][index]
    //     .get("pmdtaNumber")
    //     .updateValueAndValidity();
    // }
    // if (this.showDoublePmdtaNumber === true) {
    //   this.myForm.controls["fields"]["controls"][index]
    //     .get("doublePlayerPmdtaNumber")
    //     .updateValueAndValidity();
    // }
  }

  // Component class
  totalEntryFee(): number {
    const fixedSelectedEntryFees = this.selectedEntryFees.reduce((total, fee) => total + fee, 0);
    let selectedEntryFees = this.selectedEntryFees.reduce((total, fee) => total + fee, 0);
    if (this.fees?.platformFeeStatus) {
      if (this.fees?.platformFeeType === 'flat') {
        selectedEntryFees += this.fees?.platformFee;
      } else {
        selectedEntryFees += ((this.fees?.platformFee * fixedSelectedEntryFees) / 100);
      }
    }
    if (this.fees?.convenienceFeeStatus) {
      if (this.fees?.convenienceFeeType === 'flat') {
        selectedEntryFees += this.fees?.convenienceFee;
      } else {
        selectedEntryFees += ((this.fees?.convenienceFee * fixedSelectedEntryFees) / 100);
      }
    }
    return Math.round(selectedEntryFees);
    // return this.selectedEntryFees.reduce((total, fee) => total + fee, 0);
  }

  calculateTotalEntryFee() {
    this.selectedEntryFee = this.selectedEntryFees.reduce(
      (total, fee) => total + fee,
      0
    );
  }

  walletPay() {
    this.thankYouMsg = false;

      const registrationDeadline = moment(
    this.lastdateofregistration.replace('Z', '')
  );

  const currentTime = moment();

  this.isRegistrationExpired =
    currentTime.isSameOrAfter(registrationDeadline);

    this.Walletdialog = true;
    this.TournamentEntry = false;
    if (this.walletBalance > this.totalEntryFee()) {
      //console.log("greater");
      this.onRadioClick();
    } else {
      this.displayCashMs = true;
      this.totalleftCash = this.walletBalance - this.totalEntryFee();
      //console.log("not greater");
    }
    const formData = this.myForm.value;
    const selectedFieldGroups = formData.fields;
    let loop_count = 0;

    for (const fieldGroup of selectedFieldGroups) {
      const matchtypeValue = fieldGroup.matchTypeId;
      const agegroupValue = fieldGroup.ageGroupId;
      var matchtypeindex = this.originalCategoryAndAgeGroupList.findIndex(
        (item) => item.matchTypeId === matchtypeValue
      );
      fieldGroup.matchname = this.originalCategoryAndAgeGroupList[matchtypeindex].matchTypeName;

      var agegroupindex = this.originalCategoryAndAgeGroupList.findIndex(
        (item) => item.ageGroupId === agegroupValue
      );
      fieldGroup.agegroupname =
        this.originalCategoryAndAgeGroupList[agegroupindex].ageGroupName;

      loop_count++;
    }

    this.selectedTournamentCategory = selectedFieldGroups;
    this.selectedAgeGroup = selectedFieldGroups.map(
      (fieldGroup: any) => fieldGroup.agegroup
    );
  }
  resetFormAndVariables() {
    this.myForm.reset();
    this.selectedTournamentCategory = [];
    this.selectedPmdtaNumber = [];
    this.selectedAgeGroup = [];
  }

  thankyouModal() {
    const tournamentPlayerData = {
      category: this.myForm.value.fields,
      userId: this.loggedInUser.userdata.id,
      tournamentId: this.tournamentId,
      termsAndConditions: this.termsAndConditions,
    };
    if (this.isRadioButtonClicked) {
      if (this.walletBalance < this.totalEntryFee()) {
        this.addedAmount = Math.round(Number((this.totalEntryFee() - this.walletBalance).toFixed(2)));
        this.addCashForm.controls['amount'].setValue(this.addedAmount);
        this.showAddMoneyMessage = false;
        this.TournamentEntry = false;
        this.Addcashdialog();  
        return;
      } else {
        this.showAddMoneyMessage = false;
      }
    } else {
      this.addedAmount = Number(this.totalEntryFee());
      this.addCashForm.controls['amount'].setValue(this.addedAmount);
      this.showAddMoneyMessage = false;
      this.TournamentEntry = false;
      this.Addcashdialog(); 
      return;
    }
    this.tournamentsService
      .getTtournamentPlayerDataV2(tournamentPlayerData)
      .subscribe(
        (res) => {
          this.walletdata = res;
          let totalAmountPayable = this.walletdata.pricing.totalAmountPayable;
          let userWalletIds = [];
          let entryFee = 0;
          this.resetCountdown();
          if (this.walletdata.refundedCategories.length > 0) {
            this.refundTournamentCategoriesMessage = this.walletdata.message;
          }
          for (let x = 0; x < this.walletdata.tournamentPlayerCategoryArr.length; x++) {
            entryFee += this.walletdata.tournamentPlayerCategoryArr[x].entryFee;
            const fixedSelectedSingleCategoryEntryFees = this.walletdata.tournamentPlayerCategoryArr[x].entryFee;
            let selectedSingleCategoryEntryFees = this.walletdata.tournamentPlayerCategoryArr[x].entryFee;
            if (this.fees?.platformFeeStatus) {
              if (this.fees?.platformFeeType === 'flat') {
                selectedSingleCategoryEntryFees += this.fees?.platformFee;
              } else {
                 selectedSingleCategoryEntryFees += ((this.fees?.platformFee * fixedSelectedSingleCategoryEntryFees) / 100);
             }
            }
            if (this.fees?.convenienceFeeStatus) {
              if (this.fees?.convenienceFeeType === 'flat') {
                selectedSingleCategoryEntryFees += this.fees?.convenienceFee;
              } else {
                selectedSingleCategoryEntryFees += ((this.fees?.convenienceFee * fixedSelectedSingleCategoryEntryFees) / 100);
              }
            }
            const userwalletdata = {
              userId: this.walletdata.tournamentPlayerCategoryArr[x].userId,
              wallettype: "CASH",
              action: "SUBTRACT",
              //description: "Tournament Registration Fees",
              description: `Registered for ${this.tournamentname} tournament`,
              // amount: this.walletdata.tournamentPlayerCategoryArr[x].entryFee,
              amount: selectedSingleCategoryEntryFees,
              tournamentplayer:
                this.walletdata.tournamentPlayerCategoryArr[x]._id,
            };
            this.tournamentsService.getUserwalletData(userwalletdata).subscribe(
              (res2) => {
                userWalletIds.push(res2.id);
                if (this.walletdata.tournamentPlayerCategoryArr.length === userWalletIds.length) {
                    // const fixedSelectedEntryFees = entryFee;
                    // let selectedEntryFees = entryFee;
                    // if (this.fees?.platformFeeStatus) {
                    //   if (this.fees?.platformFeeType === 'flat') {
                    //     selectedEntryFees += this.fees?.platformFee;
                    //   } else {
                    //      selectedEntryFees += ((this.fees?.platformFee * fixedSelectedEntryFees) / 100);
                    //  }
                    // }
                    // if (this.fees?.convenienceFeeStatus) {
                    //   if (this.fees?.convenienceFeeType === 'flat') {
                    //     selectedEntryFees += this.fees?.convenienceFee;
                    //   } else {
                    //     selectedEntryFees += ((this.fees?.convenienceFee * fixedSelectedEntryFees) / 100);
                    //   }
                    // }
                  const userInvoiceData = {
                    tournamentId: this.tournamentId,
                    entryFee: Math.round(totalAmountPayable),
                    // entryFee: Math.round(selectedEntryFees),
                    // entryFee: entryFee,
                    userWalletIds: userWalletIds,
                    tournamentCategories: this.myForm.value.fields,
                  };
                  this.userWalletService
                    .addUserInvoice(userInvoiceData)
                    .subscribe((userInvoiceData) => {
                      this.thanYoumodal = true;
                      this.Walletdialog = false;
                      this.countdownInProgress = true;
                      this.cdr.detectChanges();
                      const interval = setInterval(() => {
                        this.countdown--;
                        if (this.countdown === 0) {
                          clearInterval(interval);
                          this.countdownInProgress = false;
                          this.refundTournamentCategoriesMessage = null;
                          if (this.walletdata?.refundedCategories.length > 0) {
                            for (let i=0; i < this.walletdata?.refundedCategories.length; i++) {
                              this.wid = this.walletdata?.refundedCategories[i]['_id'];
                              if ((this.walletdata?.refundedCategories.length - 1) === i) {
                                this.isRefundTournamentCategoriesCompleted = true;
                              }
                              this.thankyouwithdraw();
                            }
                          } else {
                            let currentUrl = "tournaments/factsheet/" + this.tournamentId;
                            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                            this.router.onSameUrlNavigation = "reload";
                            this.router.navigate([currentUrl]);
                          }
                        }
                        this.cdr.detectChanges();
                      }, 1000);
                    });
                }
              },
              (error) => {
                this.registrationCategoryErrorMessage = this.getRegistrationCategoryErrorMessage(error);
                this.errorMessage = this.registrationCategoryErrorMessage;
                this.Walletdialog = false;
                this.TournamentEntry = true;
                console.error("Error registering tournament player:", error);
              }
            );
          }
        },
        (error) => {
          this.registrationCategoryErrorMessage = this.getRegistrationCategoryErrorMessage(error);
          this.errorMessage = this.registrationCategoryErrorMessage;
          this.Walletdialog = false;
          this.TournamentEntry = true;
          console.error("Error registering tournament player:", error);
        }
      );
  }
  
  onHideWalletDialog() {
    this.walletDialogTermsAndConditions = false;
  }

  openAddCategory() {
    this.WithdrawModal = false;
    this.getTournamentCategoryData(this.tournamentId);
    this.getTournamentCategoryV2(this.tournamentId);
    this.TournamentEntry = true;
  }
  registeredAddField() {
    this.fieldsFormArray.clear();
    this.addField();
    this.openAddCategory();
  }

  withdraw_select(id: number, tname, mtn, agn) {
    this.withdrawButtonClicked = false;
    //this.isActive = !this.isActive;
    this.tname = tname;
    this.mtn = mtn;
    this.agn = agn;
    this.wid = id;
  }

  withdrawtournament(id, ldw) {
    this.WithdrawModal = true;
    // this.cdr.detectChanges();
    this.tournamentId = id;
    const matchingTournament = this.tournamentList.find(
      (tournament) => tournament.id === this.tournamentId
    );
    if (matchingTournament) {
      this.tournamentname = matchingTournament.name;
      this.selectedTournamentCityName = matchingTournament.citycode;
    }
    this.tournamentsService.getwithdrawtournamentData(id).subscribe(
      (res) => {
        this.withdrawtournamentData = res;
        this.registeredtournamentdata = this.withdrawtournamentData.items;
        if (this.selectedTournamentCityName == "Pune") {
          this.showPmdtaNumber = true;
        } else {
          this.showPmdtaNumber = false;
        }
        if (
          moment(this.currentDate).format("YYYY-MM-DD") >
          moment(ldw).format("YYYY-MM-DD")
        ) {
          this.withdraw_confirm_status = true;
        } else {
          this.withdraw_confirm_status = false;
        }
      },
      (error) => {
        console.error("Error registering tournament player:", error);
      }
    );
    this.withdrawButtonClicked = true;
  }

  Withdrawconfirmmodal() {
    this.WithdrawcnfModal = true;
    this.WithdrawModal = false;
    this.isRefundTournamentCategoriesCompleted = true;
  }

  thankyouwithdraw() {
    this.WithdrawcnfModal = false;
    const wbody = {
      disable: true,
      playerId: this.loggedInUser.userdata.id,
    };
    this.tournamentsService.getwithdrawamount(this.wid, wbody).subscribe(
      (res) => {
        this.wid = "";
        this.tname = "";
        this.mtn = "";
        this.agn = "";
        this.thankwithdraw = true;

        this.countdownInProgress = true;
        if (this.isRefundTournamentCategoriesCompleted) {
          this.resetCountdown();
          const interval = setInterval(() => {
            this.countdown--;
            if (this.countdown === 0) {
              clearInterval(interval);
              this.countdownInProgress = false;
              //window.location.reload();
              let currentUrl = "tournaments/factsheet/" + this.tournamentId;
              this.router.routeReuseStrategy.shouldReuseRoute = () => false;
              this.router.onSameUrlNavigation = "reload";
              this.router.navigate([currentUrl]);
            }
            this.cdr.detectChanges();
          }, 1000);
        }
      },
      (error) => {
        console.error("Error updating tournament player:", error);
      }
    );
  }

  showTournamentEntryDialog() {
    this.TournamentEntry = true;
  }
  showaddPartnerDialog(i) {
    this.resetEmailField();
    this.addPartner = true;
    this.addPartnerTermsAndConditions = false;
    this.TournamentEntry = false;
    this.partner_email_index = i;
    this.emailForm.get('phoneCode').setValue(this.countryCodeList.find(ele => ele.name === 'India'));
    this.selectedCountryCode = this.countryCodeList.find(ele => ele.name === 'India');
  }
  resetEmailField() {
    this.search_email = "";
    this.emailForm.reset();
  }

  addedPartner() {
    this.emailForm.get("mobileNumber").markAsTouched();
    this.loginemailid = this.loggedInUser.userdata.email;
    this.loginmobileNumber = this.loggedInUser.userdata.mobile;
    if (this.selectedTournamentCityName == "Pune") {
      this.showDoublePmdtaNumber = true;
    } else {
      this.showDoublePmdtaNumber = false;
    }
    if (this.emailForm.valid) {
      const doublePartnerDetails = {
        phoneCode: this.emailForm.value.phoneCode.phone_code,
        mobileNumber: this.emailForm.value.mobileNumber,
      }
      //if (emailToSearch == this.loginemailid) {
      if (doublePartnerDetails.mobileNumber == this.loginmobileNumber) {
        this.duplicateEmailError = true;
      } else {
        this.duplicateEmailError = false;
        this.tournamentsService
          .getSearchbyEmail(doublePartnerDetails)
          .subscribe((response) => {
            if (response.data.items.length > 0) {
              this.partneremailid = response.data.items[0].id;
              //this.partneremailemail = response.data.items[0].email;
              this.partneremailemail = response.data.items[0].fullName;
              this.myForm.value.fields[
                this.partner_email_index
              ].doublePlayerId = response.data.items[0].id;
              this.myForm.value.fields[
                this.partner_email_index
              ].doubleUserEmail = response.data.items[0].email;

              const doubleUserEmailControl =
                this.fieldsFormArray.controls[this.partner_email_index].get(
                  "doubleUserEmail"
                );
              doubleUserEmailControl.setValue(this.partneremailemail);
              const doubleUserIdControl =
                this.fieldsFormArray.controls[this.partner_email_index].get(
                  "doublePlayerId"
                );
              doubleUserIdControl.setValue(this.partneremailid);
              this.TournamentEntry = true;
              const selectedAgeGroupData = this.categoryAndAgeGroupList.find(
                (ageGroup) =>
                  ageGroup.ageGroupId ===
                  this.selectedAgeGroups[this.partner_email_index]
              );
              if (selectedAgeGroupData) {
                this.myForm.value.fields[this.partner_email_index].entryFee =
                  selectedAgeGroupData.entryFee;
              }

              //console.log('xxx - ', this.myForm.value);
              this.addPartner = false;
              this.TournamentEntry = true;
              this.emailerrormsg = false;
              setTimeout(()=>{
                // this.fieldsFormArray.value.forEach((ele,index) => {
                //   if (ele.doublePlayerId !== '' && ele.doubleUserEmail !== '') {
                //   }
                // })
                this.elementRef.nativeElement.querySelector("#add_double_partner_" + this.partner_email_index).style.display = "none";
                this.elementRef.nativeElement.querySelector("#double_partner_" + this.partner_email_index).style.display = "block";
              },0);
            } else {
              this.emailerrormsg = true;
            }
          });
      }
    }
  }
  clearEmailErrors() {
    this.emailerrormsg = false;
  }

  Addcashdialog() {
    this.resetDialogStates();
    this.Addcashmodal = true;
    this.Walletdialog = true;
    this.addedAmount = null; // Clear the previously entered amount
    // this.totalleftCash = this.walletBalance - this.totalEntryFee();
  }
  resetDialogStates() {
    this.Addcashmodal = false;
    this.Walletdialog = false;
  }

  Withdrawmodal() {
    this.WithdrawModal = true;
    this.Walletdialog = false;
    // this.cdr.detectChanges();
  }

  myFunction2() {
    let text = (<HTMLInputElement>document.getElementById("myInput2")).value;
    this.outputText =
      "The total of " + text + " TPL Cash will be added to your wallet.";
  }
  onRadioClick() {
    this.isRadioButtonClicked = !this.isRadioButtonClicked;
    this.displayCashMs = true;
    this.totalleftCash = this.walletBalance - this.totalEntryFee();
  }
  cashclose() {
    this.submitted = false;
  }

  toggleActive() {
    this.isActive = !this.isActive;
  }
  toggleActive2() {
    this.isActive2 = !this.isActive2;
  }
  oncickdetails(id) {
    this.router.navigate(["academies/academydetails/" + id]);
  }

  toggleShareButton() {
    this.isShareButtonClicked = !this.isShareButtonClicked;
  }

  getTotalTournamentPlayerCount() {
    this.tournamentsService
      .getTotalTournamentPlayerCount(this.tournamentId)
      .subscribe(
        (data) => {
          this.totalPlayercount = data["totalCount"];
        },
        (err) => {
          this.errorMessage = err.error.message;
        }
      );
  }
  hideDiv() {
    this.thankYouMsg = false;
  }

  onClickForgotPassword() {
    this.showForgotPasswordForm = true;
    this.visible = false;
  }

  onForgotPassBack() {
    this.showForgotPasswordForm = false;
    this.visible = true;
  }

  // onChangePMDTA(i, event){
  //   console.log(i);

  //   if(this.showPmdtaNumber === false){
  //     this.diableConfirmButton = false;
  //      this.myForm.controls['fields']['controls'][this.isActive].get('pmdtaNumber').clearValidators();

  //   }else {
  //     this.diableConfirmButton = true;
  //     this.myForm.controls['fields']['controls'][i].get('pmdtaNumber').setValidators([Validators.required]);
  //     // console.log(this.myForm);
  //   }
  // }

  onPmdtaNumberInput(event, i) {
    // const selectedAgeGroup = this.selectedAgeGroups;
    // const selectedAgeGroupData = this.subAgegroup[i].find(
    //   (ageGroup) => ageGroup.value === String(selectedAgeGroup)
    // );
    // this.myForm.value.fields[i].entryFee = selectedAgeGroupData.entryFee;
    // this.myForm.value.fields[i].tournamentCategoryId = selectedAgeGroupData.tournamentCategoryId;
    // this.myForm.value.fields[i].maxPlayer = selectedAgeGroupData.maxPlayer;
  }

  g(i: number) {
    return this.myForm.controls["fields"]["controls"][i]["controls"];
  }

  
  onTermsAndConditionsSelect(event) {
    if (event.checked) {
      this.termsAndConditionsCheck = true;
      this.showTermsAndConditionError = false;
      this.termsAndConditions = true;
    } else {
      this.termsAndConditionsCheck = false;
      this.termsAndConditions = false;
    }
  }

  onAddPartnerTermsAndConditionsSelect(event) {
    if (event.checked) {
      this.addPartnerTermsAndConditions = true;
    } else {
      this.addPartnerTermsAndConditions = false;
    }
  }

  onWalletDialogTermsAndConditionsSelect(event) {
    if (event.checked) {
      this.walletDialogTermsAndConditions = true;
    } else {
      this.walletDialogTermsAndConditions = false;
    }
  }

  getCountryCodes() {
    this.commonService.getCountryList().subscribe((data) => { 
      this.countryCodeList = data.data.items;
    })
  }
  
  setCountryCode(event) {
    this.selectedCountryCode = event.value;
  }
 
onDrawClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
  this.position = position;
  this.downloadModal = true; 
}

//Calculate the PlatformFee  in Amount
getPlatformFeeAmount(): number {
  const entryFee = this.selectedEntryFees.reduce(
    (total, fee) => total + fee,
    0
  );
  if (!this.fees?.platformFeeStatus) {
    return 0;
  }
  if (this.fees?.platformFeeType === 'flat') {
    return Number(this.fees?.platformFee || 0);
  }
  return (Number(this.fees?.platformFee || 0) * entryFee) / 100;
}
  
//Calculate the Conveniencefee in Amount
getConvenienceFeeAmount(): number {
  const entryFee = this.selectedEntryFees.reduce(
    (total, fee) => total + fee,
    0
  );
  if (!this.fees?.convenienceFeeStatus) {
    return 0;
  }
  if (this.fees?.convenienceFeeType === 'flat') {
    return Number(this.fees?.convenienceFee || 0);
  }
  return (Number(this.fees?.convenienceFee || 0) * entryFee) / 100;
}

}
